import { BursaryRequest, Transaction } from '../../types/organization/finances';

export const fetchBursaryRequests = async (organizationUuid: string): Promise<BursaryRequest[]> => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/bursary/organization/${organizationUuid}`, {
        credentials: 'include'
    });
    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Failed to fetch bursary requests');
    }
    return response.json();
};

export const fetchTransactions = async (organizationUuid: string): Promise<Transaction[]> => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/organizations/${organizationUuid}/transactions`, {
        credentials: 'include'
    });
    if (!response.ok) {
        throw new Error('Failed to fetch transactions');
    }
    return response.json();
};

export const approveBursaryRequest = async (requestUuid: string, transactionUuid: string, amount: number): Promise<void> => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/bursary/${requestUuid}/approve`, {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            transaction_uuid: transactionUuid,
            amount: amount
        })
    });

    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Failed to process refund');
    }
};

export const rejectBursaryRequest = async (requestUuid: string): Promise<void> => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/bursary/${requestUuid}/reject`, {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json'
        }
    });

    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Failed to reject bursary request');
    }
}; 